export const validate = (values, props)=> {
  const errors = {}
  if (!values.miles || !Number(values.miles)>0) {
    // field level
    errors.miles = 'Required'
    // form level
    errors._error = "Miles cannot be 0"
    // if (!props.pristine) errors._error = "Miles cannot be 0"
  }
  return errors
}



// WEBPACK FOOTER //
// ./src/trips/index.js